module.exports = __webpack_public_path__ + "static/media/english-language-sphere.9de789dd.svg";